import React from 'react'
import { BodyText, OtherText } from 'styling/Typography'

export const NoItems = ({ title, marginTop, smallText }: { title: string, marginTop?: string, smallText?: boolean }) => {
  return (
    <>
      {smallText ? <OtherText grey style={{ marginTop }} >No {title.toLowerCase()} to display</OtherText> : <BodyText grey style={{ marginTop }} >No {title.toLowerCase()} to display</BodyText>}
    </>
  )
}
